import { Money } from '../../../models/general/Money';

export class MoneyFormatter {
    static format(money: Money): string {
        return money.format(2, '.', ',');
    }
}
